import { render, staticRenderFns } from "./householdList.vue?vue&type=template&id=3ce20719&scoped=true&"
import script from "./householdList.vue?vue&type=script&lang=js&"
export * from "./householdList.vue?vue&type=script&lang=js&"
import style0 from "./householdList.vue?vue&type=style&index=0&id=3ce20719&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ce20719",
  null
  
)

export default component.exports